<template>
  <button
    :class="[buttonColor, {
      'button': true,
      'button--fullWidth': fullWidth,
      'button--outline': outline,
      'button--small': small,
      'button--hover': hovered,
      'button--transparent': transparent
    }]"
  >
    <slot>Submit</slot>
  </button>
</template>

<script>
export default {
  name: 'UnumButton',
  data () {
    return {
      buttonColor: this.color ? `button--${this.color}` : false
    }
  },
  methods: {
    test: function () {
      return false
    }
  },
  props: {
    onClick: {
      type: Function
    },
    fullWidth: {
      type: Boolean
    },
    outline: {
      type: Boolean
    },
    small: {
      type: Boolean
    },
    passClass: {
      type: Object
    },
    hovered: {
      type: Boolean
    },
    color: {
      type: String
    },
    transparent: {
      type: Boolean
    }
  }
}
</script>

<style lang="scss">
.button {
  transition: all .15s ease-in-out;
  background: $gold;
  border: .125rem solid $gold;
  border-radius: 3px;
  color: $steelblue3;
  cursor: pointer;
  font-family: $barlow;
  font-size: 1.25rem;
  font-weight: 600;
  padding: .875rem 1.5rem;
  text-transform: uppercase;
  text-decoration: none;
  line-height: 1;
  text-align: center;

  &:hover,
  &:focus {
    background: darken($gold, 5%);
    border-color: darken($gold, 5%);
  }
  &:focus {
    outline: 0;
  }

  &--white {
    color: #fff;
    border: .125rem solid #fff;
  }

  &--blue {
    color: #FFF;
    background: $blue;
    border: .125rem solid $blue;

    &.button--outline {
      color: $blue;
    }

    &:focus,
    &:hover,
    &.button--hover {
      color: #fff;
      background: lighten($blue, 5%);
      border-color: lighten($blue, 5%);
    }
  }

  &--dark-blue {
    color: #FFF;
    background: #0B3D59;
    border: .125rem solid #0B3D59;

    &.button--outline {
      color: #0B3D59;
    }

    &:focus,
    &:hover,
    &.button--hover {
      color: #fff;
      background: lighten(#0B3D59, 5%);
      border-color: lighten(#0B3D59, 5%);
    }
  }

  &--green {
    color: $steelblue3;
    background: $leaf;
    border: .125rem solid $leaf;

    &.button--outline {
      color: $leaf;
    }

    &:focus,
    &:hover,
    &.button--hover {
      color: #fff;
      background: lighten($leaf, 5%);
      border-color: lighten($leaf, 5%);
    }
  }

  &--leaf4 {
    color: #FFF;
    background: $leaf4;
    border: .125rem solid $leaf4;

    &.button--outline {
      color: $leaf4;
    }

    &:focus,
    &:hover,
    &.button--hover {
      color: #fff;
      background: lighten($leaf4, 5%);
      border-color: lighten($leaf4, 5%);
    }
  }

  &--red {
    color: #FFF;
    background: $red;
    border: .125rem solid $red;

    &.button--outline {
      color: $red;
    }

    &:focus,
    &:hover,
    &.button--hover {
      color: #fff;
      background: lighten($red, 5%);
      border-color: lighten($red, 5%);
    }
  }

  &--black {
    color: #FFF;
    background: #000;
    border: .125rem solid #000;

    &.button--outline {
      color: #000;
    }

    &:focus,
    &:hover,
    &.button--hover {
      color: #fff;
      background: lighten(#000, 10%);
      border-color: lighten(#000, 10%);
    }
  }

  &--small {
    font-size: .75rem;
    padding: .25rem 1rem;
  }

  &--fullWidth {
    display: block;
    width: 100%;
  }

  &--outline {
    background: transparent;
    &:focus,
    &:hover {
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/Button.vue